export const locale = {
    lang: 'en',
    data: {
        home: {
            title: 'Home',
            empty_message: 'No data to display',
            new_requests: 'New Requests',
            reassigned_requests: 'Reassigned Requests',
            acknowledged_requests: 'Acknowledged Requests',
            in_progress_requests: 'In-Progress Requests',
            escalated_requests: 'Escalated Requests',
            resolved_requests: 'Resolved Requests',
            
        }
    }
};
